// @flow
import ga from 'app/common/lib/ga';
import ResourceFactory from 'app/common/lib/ResourceFactory';
import type { Thunk } from 'app/common/redux/types';

function getResource(boardId) {
  return ResourceFactory.create('BoardFollowResource', {
    board_id: boardId,
  });
}

export type BoardFollow = {
  type: 'BOARD_FOLLOW',
  payload: {
    boardId: string,
    value: boolean,
  },
};

function followBoard(boardId: string, value: boolean): BoardFollow {
  return {
    type: 'BOARD_FOLLOW',
    payload: {
      boardId,
      value,
    },
  };
}

export function follow(boardId: string): Thunk<void> {
  const gaCategory = 'board-follow';
  return (dispatch) => {
    // on error, dispatch the unfollow action
    // todo (yen) - do we need to do more than this?
    getResource(boardId)
      .callCreate()
      .then(() => {
        ga.trackEvent(gaCategory, PCONST.GA_ACTION_SUCCESS);
      })
      .catch(() => {
        ga.trackEvent(gaCategory, PCONST.GA_ACTION_ERROR);
        dispatch(followBoard(boardId, false));
      });
    dispatch(followBoard(boardId, true));
  };
}

export function unfollow(boardId: string): Thunk<void> {
  const gaCategory = 'board-unfollow';
  return (dispatch) => {
    // on error, dispatch the follow action
    // todo (yen) - do we need to do more than this?
    getResource(boardId)
      .callDelete()
      .then(() => {
        ga.trackEvent(gaCategory, PCONST.GA_ACTION_SUCCESS);
      })
      .catch(() => {
        ga.trackEvent(gaCategory, PCONST.GA_ACTION_ERROR);
        dispatch(followBoard(boardId, true));
      });
    dispatch(followBoard(boardId, false));
  };
}
